import './Loading.css';
import * as React from 'react';

export default class Loading extends React.Component {
    render() {
        return <div className="loader">
            <div className="loader-box"></div>
            <div className="loader-box"></div>
            <div className="loader-box"></div>
            <div className="loader-box"></div>
            <div className="loader-box"></div>
        </div>;
    }
}